export const SET_NOTICEBOARD = "SET_NOTICEBOARD";
export const CLEAR_NOTICEBOARD = "CLEAR_NOTICEBOARD";
